<template>
  <div>

    <van-cell class="ry-form__currency" v-if="isNormalStyle">
      <template slot="title">
        <span class="title">{{current.title}}</span>
        <span style="color: red" v-if="!isRead && current.required">*</span>
      </template>
      <template slot="label">

        <template v-if="current.fieldHint">
          <froalaView v-if="$store.getters.newRtf" v-model="current.fieldHint"></froalaView>
          <div
            v-else
            class="ql-editor"
            v-html="current.fieldHint">
          </div>
        </template>
        <div
          v-if="isRead">
          {{current.currencyType === CURRENCY_TYPE__DOLLAR? '$': '￥'}} {{showValue}}{{current.showUnit}}
        </div>
        <van-field
          class="ry-form__currency-input"
          v-if="!isRead"
          type="number"
          :readonly="isReadOnly"
          @change="valueChange"
          @blur="inputBlur"
          @focus="inputFocus"
          v-model="content"
          :placeholder="current.fieldDes"
          :error-message="errorMessage">
          <i slot="left-icon">
            {{current.currencyType === CURRENCY_TYPE__DOLLAR? '$': '￥'}}
          </i>
          <div slot="extra" style="display: flex; align-items: center;">{{current.showUnit}}</div>
        </van-field>
        <span v-if="isShowUpper">{{current.upper}}</span>
      </template>
    </van-cell>

    <div v-else class="ry-form-item-compact ry-form__currency-compact">

      <van-field
        v-if="isRead"
        :label="current.title"
        :required="Boolean(!isRead && current.required)">
        <template #input>
          <div>
            {{current.currencyType === CURRENCY_TYPE__DOLLAR? '$': '￥'}} {{showValue}}{{current.showUnit}}
          </div>
        </template>
      </van-field>

      <van-field
        v-if="!isRead"
        type="number"
        :label-class="{'readonly-field-label': isReadOnly}"
        :readonly="isReadOnly"
        @change="valueChange"
        @blur="inputBlur"
        @focus="inputFocus"
        v-model="content"
        :placeholder="isReadOnly ? '暂无内容' : '请填写内容'"
        :required="Boolean(!isRead && current.required)">
        <template slot="label">
          <span>
            <span class="title">{{current.title}}</span>
            ({{current.currencyType === CURRENCY_TYPE__DOLLAR? '$': '￥'}})
          </span>
        </template>

        <div slot="extra" style="display: flex; align-items: center;">{{current.showUnit}}</div>
      </van-field>
      <span v-if="isShowUpper" class="upper">{{current.upper}}</span>
    </div>
  </div>
</template>
<script>
  import {current} from './mixin'
  import {CURRENCY_TYPE__DOLLAR, CURRENCY_TYPE__RMB} from '../types'
  import {formatNum} from "../../../assets/js/Untis";

  export default {
    mixins: [current],
    data() {
      return {
        CURRENCY_TYPE__DOLLAR,
        isError: false
      }
    },
    computed: {
      content: {
        set(newVal) {
          if (newVal) {

            if (this.current.checkCondition.numLimit) {
              if (newVal < this.current.checkCondition.minNum) {
                this.$toast.fail(`输入值不能小于${this.current.checkCondition.minNum}`)
                return
              } else if (newVal > this.current.checkCondition.maxNum) {
                this.$toast.fail(`输入值不能大于${this.current.checkCondition.maxNum}`)
                return
              }
            }
            if (this.current.checkCondition.integerOnly) {
              // 只能是整数
              if (newVal.includes('.')) {
                this.$toast.fail(`输入值不能是小数`)
                return
              }
            } else {
              // 可以有小数
              if (this.current.checkCondition.decimalLimit) {
                // 开启小数位数验证
                if (newVal.toString().split(".")[1] &&
                  newVal.toString().split(".")[1].length > this.current.checkCondition.decimalCount) {
                  this.$toast.fail(`输入值小数位数不能大于${this.current.checkCondition.decimalCount}位`)
                  return
                }
              }
            }

            // this.current.value = Number(newVal)
            this.current.value = newVal
              .replace(/[^\-?\d.]/g, "")
          } else {
            this.current.value = null
          }

          // .replace(/[^\d.]/g, "")   // 清除“数字”和“.”以外的字符
          // .replace(/^\./g, "")      // 验证第一个字符是数字而不是.
          // .replace(".", "$#$")
          // .replace(/\./g, "")
          // .replace("$#$", ".")
        },
        get() {
          return this.current.value
        }
      },
      isShowUpper() {
        return this.current.showUpper && this.current.currencyType === CURRENCY_TYPE__RMB
      },
      errorMessage() {
        return this.isError ? this.current.requiredShowText : ''
      },
      showValue() {
        if (this.current.tp === 'YES') {
          return formatNum(this.current.value)
        } else {
          return this.current.value
        }
      }
    },
    methods: {
      inputBlur() {

        if (!this.current.value) {
          this.current.value = 0
        }
        this.isError = this.current.checkMissValue && this.isShowRequiredText
      },
      // Input 获得焦点时触发
      inputFocus() {
        if (!this.current.value || !Number(this.current.value)) {
          this.current.value = null
        }
      },
      valueChange() {
        // this.current.value = Number(this.current.value)
        this.controlChange()
      }
    },
    components: {},
    watch: {}
  }
</script>

<style lang="less">
  .ry-form__currency-compact {

    .upper {
      margin-left: 124px;
      font-size: 12px;
      color: #323233;
      display: block;
      padding-bottom: 5px;
    }
  }
</style>
